import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import All from "./all";
import Exact from "./exact";
import Pending from "./pending";
import ProtectedRoute from "../../../../components/util-components/ProtectedRoute";

const PARENT_URL = "/cms/customers";

const Companies = () => {
  return (
    <Routes>
      <Route
        path={`/all`}
        element={
          <ProtectedRoute routeKey={"shop-companies-existing"}>
            <All />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/exact`}
        element={
          <ProtectedRoute routeKey={"shop-companies-exact"}>
            <Exact />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/pending`}
        element={
          <ProtectedRoute routeKey={"shop-companies-pending"}>
            <Pending />
          </ProtectedRoute>
        }
      />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/customers`} replace />} />
    </Routes>
  );
};

export default Companies;
